import firebase from 'firebase/app'
import 'firebase/firestore'



let firebaseConfig = {
    apiKey: "AIzaSyDrzQVkor3Uwi6yKAs2dQPuQtbuH5U24ck",
    authDomain: "devquiz-49fda.firebaseapp.com",
    projectId: "devquiz-49fda",
    storageBucket: "devquiz-49fda.appspot.com",
    messagingSenderId: "500094529000",
    appId: "1:500094529000:web:b13936b4cbc5dd738ac85d",
    measurementId: "G-BF18WFGDL7"
};

// Initialize Firebase

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

export default firebase;
